// extracted by mini-css-extract-plugin
module.exports = {"title":"modal_title__138MG"};